<template>
    <div class="formation_container">
        <el-select
            v-if="!disabled"
            popper-class="formation_select_class"
            v-model="formationValue"
            :placeholder="$t('common.请选择')"
            class="formation_select"
            @change="changeFormation"
        >
            <el-option
                v-for="item in formationOptions"
                :key="item.value"
                :label="item['label'+$lang]"
                :value="item.value"
            ></el-option>
        </el-select>
        <p v-else class="formation_select_value">{{ formationText }}</p>
        <div v-if="showPreview" class="pdf" @click="$emit('pdf-preview')">
            <cl-svg-icon class="pre_view" iconClass="preview" width="20"></cl-svg-icon>
        </div>
        <div
            v-for="(item, index) in formationPosition[formationValue]"
            :key="index+'formation'"
            :style="{ 'left': item.left + 'px', 'top': item.top + 'px' }"
            class="formation_card"
        >
            <p class="shirt">
                <img class="shirt_icon" src="@/assets/images/cfa/shirt.svg" alt />
                <span>{{ item.position }}</span>
            </p>
            <!-- <p class="corner" :style="{'background': currentColor}"></p> -->
            <!-- 22.7.5 确认不区分客户类型 -->
            <p class="corner" :style="{'background': '#E23838'}"></p>
            <div class="formation_player">
                <div
                    v-for="player in item.playerList.slice(0, 3)"
                    :key="player.id+item.position"
                    class="formation_item"
                    :class="{'disabled_item': disabled}"
                >
                    <p
                        class="avatar_box"
                        :class="{
                        'no_team': !player.inTeam,
                        'trial': player.trial
                    }"
                    >
                        <cl-avatar :src="player.avatar" :round="true" width="24" height="24"></cl-avatar>
                    </p>
                    <span class="number">{{ player.number }}</span>
                    <span class="name">{{ player['name' + $lang] || '--' }}</span>
                    <cl-svg-icon
                        class="delete_icon"
                        width="20"
                        iconClass="delete"
                        @click.native="delPlayer(player, item)"
                    ></cl-svg-icon>
                </div>
                <div v-if="item.playerList.length < 3" class="no_data">
                    <cl-people-list
                        class="add_btn_box"
                        :disabled="disabled"
                        :only-pop="true"
                        :show-player-status="false"
                        v-model="tempId"
                        :list="playerList"
                        :custom-disabled="disabledIdList"
                        :no-data-text="$t('schedule.请添加球员组球员')"
                        @visible-change="selectChange($event, item)"
                        @change="addPlayer($event, item)"
                    >
                        <cl-button class="add_btn" type="level-2" v-if="showPreview"></cl-button>
                    </cl-people-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // 球员列表
        playerList: {
            type: Array,
            default: () => []
        },
        // 是否禁用
        disabled: {
            type: Boolean,
            default: false
        },
        // 显示预览icon
        showPreview: {
            type: Boolean,
            default: true
        },
        // 阵型文字
        formationText: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            tempId: '',      // 临时Id
            currentColor: this.backgroundColor,// 当前色值
            disabledIdList: [],     // 禁用选项
            formationValue: '',     // 当前阵型
            formationOptions: [     // 阵型选项
                { label: '1-4-3-3', labelEn: '1-4-3-3', value: '1-4-3-3' },
                { label: '1-4-4-2', labelEn: '1-4-4-2', value: '1-4-4-2' },
                { label: '1-3-5-2', labelEn: '1-3-5-2', value: '1-3-5-2' }
            ],
            formationPosition: {    // 阵型位置选项
                '1-4-3-3': [
                    { left: 321, top: 532, position: 1, playerList: [] },
                    { left: 40, top: 366, position: 5, playerList: [] },
                    { left: 228, top: 366, position: 4, playerList: [] },
                    { left: 416, top: 366, position: 3, playerList: [] },
                    { left: 604, top: 366, position: 2, playerList: [] },
                    { left: 133, top: 204, position: 8, playerList: [] },
                    { left: 321, top: 204, position: 6, playerList: [] },
                    { left: 509, top: 204, position: 10, playerList: [] },
                    { left: 133, top: 40, position: 11, playerList: [] },
                    { left: 321, top: 40, position: 9, playerList: [] },
                    { left: 509, top: 40, position: 7, playerList: [] },
                ],
                '1-4-4-2': [
                    { left: 321, top: 532, position: 1, playerList: [] },
                    { left: 40, top: 366, position: 5, playerList: [] },
                    { left: 228, top: 366, position: 4, playerList: [] },
                    { left: 416, top: 366, position: 3, playerList: [] },
                    { left: 604, top: 366, position: 2, playerList: [] },
                    { left: 40, top: 204, position: 8, playerList: [] },
                    { left: 228, top: 204, position: 10, playerList: [] },
                    { left: 416, top: 204, position: 6, playerList: [] },
                    { left: 604, top: 204, position: 7, playerList: [] },
                    { left: 228, top: 40, position: 11, playerList: [] },
                    { left: 416, top: 40, position: 9, playerList: [] },
                ],
                '1-3-5-2': [
                    { left: 321, top: 532, position: 1, playerList: [] },
                    { left: 131, top: 366, position: 5, playerList: [] },
                    { left: 321, top: 366, position: 3, playerList: [] },
                    { left: 501, top: 366, position: 2, playerList: [] },
                    { left: 20, top: 204, position: 8, playerList: [] },
                    { left: 171, top: 204, position: 10, playerList: [] },
                    { left: 321, top: 204, position: 6, playerList: [] },
                    { left: 473, top: 204, position: 4, playerList: [] },
                    { left: 624, top: 204, position: 7, playerList: [] },
                    { left: 228, top: 40, position: 11, playerList: [] },
                    { left: 416, top: 40, position: 9, playerList: [] },
                ]
            },
        };
    },
    computed: {
        backgroundColor () {
        }
    },
    watch: {
        playerList: {
            handler (newVal, oldVal) {
                // positionNumber positionOrderNum
                if (newVal !== oldVal) {
                    this.getPlayerPos();
                }
            },
            deep: true
        }
    },
    mounted () {
        this.formationValue = this.formationOptions[0].value;
    },
    methods: {
        // 设置阵型时
        setFormation (val) {
            this.formationValue = val;
            this.getPlayerPos();
        },
        // 改变阵型时
        changeFormation (val) {
            this.$emit('change-formation', val);
            this.getPlayerPos();
        },
        // 重置阵型
        resetFormation () {
            this.formationPosition = this.$options.data().formationPosition;
        },
        // 获取球员位置关系
        getPlayerPos () {
            // 重置阵型
            this.resetFormation();
            // 当前的阵型
            let currentFormation = this.formationPosition[this.formationValue];
            this.playerList.forEach(playerItem => {
                currentFormation.forEach(formationItem => {
                    if (playerItem.position_number) {   // 如果有球员位置号信息
                        let posList = JSON.parse(playerItem.position_number);
                        posList.forEach(item => {
                            let playerPosition = item[0];   // 球员位置号
                            let orderNum = item[1];         // 球员位置排序号
                            if (playerPosition === formationItem.position) {
                                formationItem.playerList.push({
                                    ...playerItem,
                                    orderNum
                                })
                            }
                        })
                    }
                    if (!formationItem.playerList.length) return;
                    // 根据球员位置排序号-升序排序
                    formationItem.playerList.sort((a, b) => a.orderNum - b.orderNum);
                })
            });
            // console.log(this.formationPosition[this.formationValue]);
        },
        // 选中人员下拉框显隐
        selectChange (flag, item) {
            if (flag) {
                this.disabledIdList = item.playerList.map(i => i.id);
            }
        },
        // 添加球员
        addPlayer (playerId, formationItem) {
            let currentPlayer = this.playerList.find(i => i.id === playerId); // 当前球员
            let playerPos = currentPlayer.position_number && JSON.parse(currentPlayer.position_number) || [];     // 当前球员的位置信息
            let newPos = [];    // 当前球员新的位置信息
            newPos[0] = formationItem.position;      // 阵型的位置号
            newPos[1] = 1;          // 位置排序号 默认为1
            if (formationItem.playerList.length) {  // 如果该位置下有球员列表则 取出最大值并+1
                let maxOrderNum = formationItem.playerList.sort((a, b) => { return b.orderNum - a.orderNum })[0].orderNum;
                newPos[1] = maxOrderNum + 1;
            }
            playerPos.push(newPos);     // 添加新的球员位置
            this.$nextTick(() => {
                this.tempId = '';   // 将当前选中球员清空
            });
            this.updateInfo(currentPlayer, playerPos);    // 更新球员信息
        },
        // 删除球员
        delPlayer (playerItem, formationItem) {
            if (this.disabled) return;
            let playerPos = JSON.parse(playerItem.position_number);     // 当前球员的位置信息
            let delPos = formationItem.position;    // 删除阵型的位置号
            let delItem = playerPos.find(item => item[0] === delPos);   // 删除的item项
            let delIndex = playerPos.findIndex(item => item === delItem);    // 删除的index下标
            playerPos.splice(delIndex, 1);
            this.updateInfo(playerItem, playerPos);    // 更新球员信息
        },
        // 更新球员信息
        updateInfo (item, pos) {
            let data = {
                id: item.id,
                position_number: JSON.stringify(pos)
            }
            let params = {
                type: 'player',
                tab: 'personal'
            }
            // console.log(data, params, 'update');
            this.$server.updateUser(data, params).then(res => {
                if (res.code === 200) {
                    this.$emit('update-info');
                }
            })
        }
    }
}
</script>
<style lang='scss'>
.formation_select_class {
    .el-select-dropdown__item {
        height: 42px;
        line-height: 42px;
        font-family: 'AkrobatMedium';
    }
}
</style>
<style lang='scss' scoped>
.add_btn_box {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    position: relative;
    .add_btn {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
}
.formation_container {
    width: 786px;
    min-height: 680px;
    margin-right: 16px;
    border-radius: 6px;
    background: url('~@i/cfa/team_formation_bg.svg') no-repeat;
    background-size: 100%;
    position: relative;
    /deep/ .formation_select {
        position: absolute;
        top: 12px;
        left: 12px;
        .el-input__inner {
            width: 84px;
            height: 34px;
            padding: 0 8px;
            background: rgba(0, 0, 0, 0.16);
            border: none;
            border-radius: 6px;
            font-family: 'AkrobatMedium';
            font-weight: 700;
            font-size: 18px;
            line-height: 22px;
            color: #fff;
        }
        .el-input__suffix {
            .el-select__caret {
                color: #fff;
                line-height: 34px;
            }
        }
    }
    .formation_select_value {
        position: absolute;
        top: 16px;
        left: 16px;
        font-family: 'AkrobatMedium';
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #fff;
    }
    .pdf {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 34px;
        height: 34px;
        background: rgba(0, 0, 0, 0.16);
        border-radius: 6px;
        padding: 7px;
        box-sizing: border-box;
        cursor: pointer;
        &:hover {
            background-color: #3663e1;
        }
        svg {
            color: #fff;
        }
    }
    .formation_card {
        width: 143px;
        height: 132px;
        padding-top: 7px;
        border-radius: 4px;
        box-sizing: border-box;
        position: absolute;
        .shirt {
            width: 32px;
            height: 32px;
            position: absolute;
            top: -1px;
            right: -4px;
            .shirt_icon {
                width: 100%;
                height: 100%;
                color: #fff;
            }
            span {
                width: 32px;
                height: 32px;
                position: absolute;
                top: 0;
                right: 0;
                text-align: center;
                line-height: 28px;
                font-family: 'AkrobatMedium';
                font-weight: 900;
                font-size: 16px;
                color: #fff;
            }
        }
        .corner {
            width: 100%;
            height: 5px;
            border-radius: 4px 4px 0 0;
        }
        .formation_player {
            height: 122px;
            box-sizing: border-box;
            border-radius: 0 0 4px 4px;
            padding: 16px 0 8px 0;
            background: rgba(8, 8, 8, 0.4);
            box-shadow: 0px 16px 8px rgba(0, 0, 0, 0.06);
            overflow: hidden;
            > .formation_item {
                height: 32px;
                display: flex;
                align-items: center;
                margin: 0 8px;
                border-bottom: 1px solid rgba(255, 255, 255, 0.1);
                cursor: pointer;
                &:last-child {
                    border-bottom: none;
                }
                &:hover {
                    margin: 0 4px;
                    padding: 0 4px;
                    background: $base-color-theme;
                    border-radius: 2px;
                    .delete_icon {
                        display: inline-block;
                    }
                }
                &:last-child {
                    border-bottom: none;
                }
                &.disabled_item {
                    &:hover {
                        background: transparent;
                    }
                    .delete_icon {
                        display: none;
                    }
                }
                .avatar_box {
                    width: 26px;
                    height: 26px;
                    border-radius: 50%;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    &.no_team {
                        border: 2px solid #916ce6;
                    }
                    &.trial {
                        border: 2px solid #34b5e8;
                    }
                }
                span {
                    font-size: 12px;
                    line-height: 17px;
                    color: #fff;
                    &.number {
                        font-family: 'AkrobatR';
                        font-size: 14px;
                        margin-left: 6px;
                        width: 18px;
                    }
                    &.name {
                        width: 50%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
                .delete_icon {
                    position: absolute;
                    right: 4px;
                    color: #fff;
                    display: none;
                }
            }
            div.no_data {
                display: flex;
                align-items: center;
                justify-content: center;
                &:hover {
                    background: transparent;
                }
            }
        }
    }
}
</style>
